export default "__VITE_ASSET__CYi01uIH__"